// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3de9a470","931":"2b4335f6"}[chunkId] + ".chunk.js";
};